export default __webpack_public_path__ + "static/media/milestone 30.98cd349c.svg";